import { FormattedMessage } from 'react-intl'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { isEmpty, map } from 'lodash'
import FlexColumn from './FlexColumn'

function ResourceList({ items, renderItem, emptyMessageId }) {
  if (isEmpty(items)) {
    return (
      <Box sx={{ py: 2 }}>
        <Typography color="text.secondary">
          <FormattedMessage id={emptyMessageId} />
        </Typography>
      </Box>
    )
  }

  return (
    <FlexColumn gap={1}>
      {map(items, renderItem)}
    </FlexColumn>
  )
}

export default ResourceList
